import script from "./UploadsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadsTable.vue?vue&type=script&lang=ts&setup=true"

import "./UploadsTable.vue?vue&type=style&index=0&id=b9a6a3fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9a6a3fc"]])

export default __exports__